import { render, staticRenderFns } from "./qcmReview.vue?vue&type=template&id=3e347aa6&"
import script from "./qcmReview.vue?vue&type=script&lang=js&"
export * from "./qcmReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports